import { Vector2, TextureLoader, BufferGeometry, PlaneGeometry, Camera, MeshBasicMaterial, Mesh, Vector3, DoubleSide, Object3D } from "three";
import { ClickMesh } from "./ClickMesh";


const iconType = {
  bath: "bath",
  camera: "camera",
  hall: "hall",
  kitchen: "kitchen",
  living: "living",
  room: "room",
  pin: "pin"
}

export class Hotspot extends ClickMesh {
  private position: Vector3;

  constructor(node:Object3D, size) {
    super(node);
    this.position = new Vector3();
    node.getWorldPosition(this.position);
    const geometry = new PlaneGeometry(size, size);
    const kind = this.getTypeFromName(node.name);
    var texture = new TextureLoader().load(window.location + "/public/images/icon_" + kind + ".png");
    var material = new MeshBasicMaterial({ map: texture, transparent: true, alphaTest: 1.0, color: 0xFFFFFF, side: DoubleSide });
    this._mesh = new Mesh(geometry, material);
    this._mesh.position.copy(this.position);
    //override Names!!
    this._mesh.name = node.name;
    this._name = node.name;
    this._mesh.name = "HSMESH_" + node.name;
    this._id = this._mesh.uuid;
    //this.plane.renderOrder = 1;
  }
  getTypeFromName(name: string) {
    if (name.toLowerCase().includes("bath")) return iconType.bath;
    if (name.toLowerCase().includes("camera")) return iconType.camera;
    if (name.toLowerCase().includes("hall")) return iconType.hall;
    if (name.toLowerCase().includes("kitchen")) return iconType.kitchen;
    if (name.toLowerCase().includes("living")) return iconType.living;
    if (name.toLowerCase().includes("room")) return iconType.room;
    return iconType.pin;
  }

  show() { }
  hide() { }

  update(newPos):void {
    this._mesh.lookAt(newPos);
  }
}